import React from "react";
import "./HeaderStyle.sass"
import {connect} from "react-redux";
import {logOutMe} from "../../Redux/authReducer";
import user from "../../img/headerIM/user.png"
import exit from "../../img/headerIM/exit.png"
import Preloader from "../../Utilits/Preloader/Preloader";
const Header = (props) => {
    return (
        <>
            {props.isPreloader ? <Preloader/> : null}
            <header className='header-app'>
                <p className='header-app__active_page'>{props.activePageSite} PAGE</p>
                <div className="header-app__user-avatar">
                    <div className="">
                        <img src={user} alt=""/>
                    </div>
                    <p>{props.login}</p>
                    {props.isAuth && <button onClick={props.logOutMe}><img src={exit} alt=""/></button>}
                </div>
            </header>
        </>
    )
};

let mapStateToProps = (state) => {
    return {
        activePageSite: state.auth.activePageSite,
        isAuth: state.auth.isAuth,
        isPreloader: state.auth.isPreloader,
        login: state.auth.login
    }
};

export default connect(mapStateToProps, {logOutMe})(Header)